import React from "react";
import "./dhipaya_sabaijai.css";

export default function DhipayaSabaijaiCard({ onSelect }) {
  return (
    <div className="pkg-card dhipaya-sabaijai">
      <div className="pkg-body">
        <h3>สบายใจชัวร์ 2+ / 3+</h3>
        <p>ทิพยประกันภัย — แผนคุ้มครองรถส่วนบุคคลและรถกระบะ ≤ 3 ตัน</p>

        <ul className="pkg-list">
          <li>ชนกับยานพาหนะทางบก (3+)</li>
          <li>สูญหาย / ไฟไหม้ (เฉพาะ 2+)</li>
          <li>ทุน 100,000 – 500,000 บาท</li>
          <li>อายุรถ ≤ 20 ปี</li>
          <li>เบี้ยเริ่มต้น 6,599 บาท (3+)</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>ดูตารางเบี้ย</button>
      </div>
    </div>
  );
}
